import React from 'react';

const PageTransition = ({ children }) => {
    return (
        <div className="page-transition w-full">
            {children}
        </div>
    );
};

export default PageTransition;
